/**
 * Economy: tracks the player's budget, income, and expenses.
 * Pure logic, no Phaser dependency.
 */
export class Economy {
  private _balance: number;
  private _totalIncome = 0;
  private _totalExpenses = 0;

  constructor(startingBalance: number) {
    this._balance = startingBalance;
  }

  get balance(): number {
    return this._balance;
  }

  get totalIncome(): number {
    return this._totalIncome;
  }

  get totalExpenses(): number {
    return this._totalExpenses;
  }

  canAfford(amount: number): boolean {
    return this._balance >= amount;
  }

  spend(amount: number): boolean {
    if (!this.canAfford(amount)) return false;
    this._balance -= amount;
    this._totalExpenses += amount;
    return true;
  }

  addIncome(amount: number): void {
    this._balance += amount;
    this._totalIncome += amount;
  }

  deductOperatingCosts(totalCost: number): void {
    this._balance -= totalCost;
    this._totalExpenses += totalCost;
  }
}
